import { WorkRequestActionTypes } from '../actions';

export default function(state = {}, action) {
  switch (action.type) {
    case WorkRequestActionTypes.GET:
      let { data } = action.payload;
      return { ...state, data };
    case WorkRequestActionTypes.CREATE:
    case WorkRequestActionTypes.UPDATE:
    case WorkRequestActionTypes.FIND:
      return action.payload.data;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/workrequest.reducer.js